import { DateTime } from "luxon";

/**
 * Checks whether a given date's month falls outside the [from, to] range. Comparison is done at
 * month granularity — the day within each date is ignored.
 */
export function isMonthOutOfRange(date: Date, from?: Date, to?: Date): boolean {
  const dateDT = DateTime.fromJSDate(date).startOf("month");
  const after = from && DateTime.fromJSDate(from).startOf("month") > dateDT;
  const before = to && DateTime.fromJSDate(to).startOf("month") < dateDT;
  return !!(after || before);
}
